import * as React from "react";
import {Suspense} from "react";
import {Accordion as BootstrapAccordion} from "react-bootstrap";
import {Questions} from "../../../userContent/questions";
import {useAccordionItemBodyStatus} from "../../../../../hooks/useAccordionItemBodyStatus";
import {useAccordionVariables} from "../../../../../hooks/useAccordionVariables";
import {AccordionItemType} from "../../../../../definitions/enums";
import {
    useQuestionAndAnswerAccordionHeaderQuery
} from "../../../../../hooks/useQuestionAndAnswerAccordionHeaderQuery";
import {useAppContext} from "../../../../../hooks/useAppContext";
import {ErrorBoundary} from "@sentry/react";
import {ZeroQuestions} from "../../../userContent/zeroQuestions";

export const QuestionAndAnswers = () => {
    return (
        <ErrorBoundary fallback={<></>}>
            <Header/>
            <Body/>
        </ErrorBoundary>
    )
}

const Header = () => {
    const {onClick} = useAccordionVariables();
    return (
        <BootstrapAccordion.Header className="fs-3" onClick={() => onClick(AccordionItemType.QuestionAndAnswers)}>
            <Suspense fallback={<>Questions & Answers</>}>
                <Title/>
            </Suspense>
        </BootstrapAccordion.Header>
    )
}

const Title = () => {
    const {title, subtitle} = useQuestionAndAnswerAccordionHeaderQuery();
    return (
        <>
            {title}
            {subtitle && (
                <div className="ms-2">
                    {subtitle}
                </div>
            )}
        </>
    )
}

const Body = () => {
    const {questionCount} = useAppContext();
    const {hasEntered, onEnter} = useAccordionItemBodyStatus();

    return (
        <BootstrapAccordion.Body className="border-bottom" onEnter={onEnter}>
            {((questionCount ?? 0) === 0) ? <ZeroQuestions/> : hasEntered && <Questions/>}
        </BootstrapAccordion.Body>
    );
};